async function consultar(requisicao, mensagem) {
  try {
    const response = await requisicao;
    const body = response.data;
    if (!body || body.success !== true) throw new Error(body && body.msg || mensagem);
    return body;
  } catch (e) {
    throw new Error(e.data && e.data.msg || e.message || mensagem);
  }
}

export default {
  disponivel: true,
  async buscar({ http, id_auth, status = 'pending', skip = 0, limit = 50 }) {
    const body = await consultar(http.get('v2/integracoes/pedidos', {
      params: { id_auth, status, skip, limit }
    }), 'Não foi possível buscar os pedidos.');
    if (!Array.isArray(body.orders)) throw new Error('Resposta inválida ao buscar pedidos.');
    return body.orders;
  },
  async importar({ http, id_auth, pedido }) {
    const body = await consultar(http.post('v2/integracoes/pedidos/importar', {
      id_auth: Number(id_auth), external_order_id: pedido.external_order_id
    }, { emulateJSON: false, headers: { 'Content-Type': 'application/json' } }), 'Não foi possível solicitar a importação.');
    if (!['processing', 'imported'].includes(body.import_status)) {
      throw new Error('Não foi possível confirmar a importação. Atualize a lista antes de tentar novamente.');
    }
    return body;
  }
};
